<template>
  <b-container class="accueil">
    <div class="contains w-25">
      <b-button
        to="/Resultats"
        block
        class="backresultats button_accueil_style mb-4"
        >Vos résultats</b-button
      >
      <b-button
        v-if="$root.user.roles.ENREG === 1"
        to="/Demande/Nouvelle"
        block
        class="backanalyse button_accueil_style mb-4"
        >Demandes d'analyses</b-button
      >
      <!-- <b-button to="/Catalogue" block class="backcatalogue button_accueil_style mb-4">Catalogue et tarifs</b-button>
      <b-button to="/Rapports" block class="backrapports button_accueil_style">Vos rapports d'essais</b-button> -->
    </div>
  </b-container>
</template>


<script>
export default {
  name: 'AccueilComponent',
  data () {
    return {
    }
  },
  methods: {

  },
  computed: {

  }
}
</script>

<style>
@media (min-width: 1024px) {
  .accueil {
    background-image: url("../assets/backacc.jpg");
    background-size: cover;
    max-width: 100%;
    height: 44.8vw;
    display: flex;
    align-items: center;
  }
  .button_accueil_style {
    background-color: #ffffff;
    border-color: white;
    border-radius: 0px 20px 0px 20px;
    font-size: 1.3vw;
  }
}
@media (max-width: 1024px) {
  .accueil .contains {
    width: 75% !important;
  }
  .button_accueil_style {
    background-color: #ffffff;
    border-color: white;
    border-radius: 0px 20px 0px 20px;
    font-size: 3vw;
  }
}
.accueil {
  max-width: 100%;
  padding-top: 85px;
}
.accueil .contains {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 2%;
  border-radius: 0px 20px 0px 20px;
}
.button_accueil_style:hover {
  background-color: white;
  border: #509eb3 2px solid;
  color: #509eb3;
}
.backresultats {
  background: #24509e;
}
.backanalyse {
  background: #0071bc;
}
.backcatalogue {
  background: #53a3ab;
}
.backrapports {
  background: #f7931e;
}
</style>




// WEBPACK FOOTER //
// src/components/AccueilComponent.vue